/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".email-receipt[_ngcontent-%COMP%]{z-index:unset!important}.fa-custom[_ngcontent-%COMP%]{font-size:24px;color:#666}"];
export { styles as styles };
